export const mapStationToPost = (station) => {
  const model = {
    // thông tin trạm
    stationCode: station.stationCode,
    stationsName: station.stationsName,
    stationsId: station.stationsId,
    stationArea: station.stationArea,
    stationsAddress: station.stationsAddress,
    stationsHotline: station.stationsHotline,
    stationsEmail: station.stationsEmail,
    stationsLogo: station.stationsLogo,
    stationsBanner: station.stationsBanner || '',
    // thông tin bài viết
    introContent: station.introContent,
    introCtaText: station.introCtaText,
    introMedia: station?.introMedia ? JSON.parse(station?.introMedia) : {},
    introUpdatedAt: station.introUpdatedAt,
    stationLabelCTA: station.stationLabelCTA,
    // tương tác
    ratingPoint: station.ratingPoint || 0,
    countReview: station.countReview || 0,
    totalCustomerScheduleCount: station.totalCustomerScheduleCount || 0,
    totalCustomerRecordCount: station.totalCustomerRecordCount || 0,
    // thông tin khác
    apiKey: station.apiKey,
    linkBooking: station.linkBooking
  }
  return model
}
